import Link from 'next/link'
import CloseIcon from '@/icons/24/cross.svg'
import Logo from '@/icons/logo-with-name-horizontal.svg'

interface CheckoutHeaderV2Props {
  onClose: () => void
}

export function CheckoutHeaderV2({ onClose }: CheckoutHeaderV2Props) {
  return (
    <div className="bg-fill-senary fixed px-2 top-0 z-10 w-full flex justify-center h-12 items-center border-b border-b-secondary px-s">
      <Link href="/">
        <Logo />
      </Link>

      <button className="absolute right-0 top-0 bottom-0" onClick={onClose}>
        <CloseIcon className="m-3" />
      </button>
    </div>
  )
}
